import { render, staticRenderFns } from "./Mcc.vue?vue&type=template&id=721d38cd&scoped=true&"
import script from "./Mcc.vue?vue&type=script&lang=js&"
export * from "./Mcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d38cd",
  null
  
)

export default component.exports